import React from "react";
import "./Body.css";
import { Row, Col } from "reactstrap";
import videoUrl from "./EntirosIntegrations_MASTER.mp4";
import playButton from "../../img/play-button.png";

export default class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideoMuted: true,
      isVideoPlayed: false
    };

    this.playVideo = this.playVideo.bind(this);
  }

  playVideo = () => {
    let video = document.getElementById("video");
    video.currentTime = 0;
    this.setState(prevState => ({
      isVideoPlayed: !prevState.isVideoPlayed,
      isVideoMuted: !prevState.isVideoMuted
    }));
  };

  render() {
    return (
      <div className="start-video-container col-md-12">
        {this.state.isVideoPlayed}
        <video
          id="video"
          muted={this.state.isVideoMuted}
          src={videoUrl}
          className={`start-bg-video  d-flex justify-content-md-center col-lg-6 col-md-12 col-sm-12 ${
            !this.state.isVideoPlayed ? "bg-playing" : "playing"
          }`}
          autoPlay={true}
          loop
          poster={"../images/video-bg.jpg"}
        />
        {!this.state.isVideoPlayed && (
          <div className="start-video-text text-center">
            <img
              src={playButton}
              className="d-block mx-auto"
              onClick={this.playVideo}
              alt="Play button"
            ></img>
            <span className="videobanner-text">
              A quality standard for system integrations, <br />
              providing best-practice guidelines for more <br />
              secure and reusable integrations.
              <br />
            </span>
            <span className="videobanner-link">
              <button onClick={this.playVideo}>
                Watch introduction video
              </button>
            </span>
          </div>
        )}
        <Row className="start-bg-btn row justify-content-md-center">
          <Col lg="8" md="12">
            <div className="text-center">
              <a className="int-btn blue-btn" href="/business-benefits">
                SEE THE BUSINESS BENEFITS
              </a>
              <a className="int-btn green-btn m-l-50" href="/get-certified">
                BECOME A CERTIFIED INTEGRATOR
              </a>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
